import { isAdobeUpdatesOn } from '../../../../utils/stellantis/utils';

export default {
	events: {
		'ddc.link.generic': {
			insertion: 'unshift',
			// US2093316: legacy linkText CTA. With the
			// ws-tagging-stellantis-adobe-updates flag ON this rule stands down so
			// the click falls through to the granular CTA catch-all in
			// event/default.js, which reports it in the 2.0 taxonomy. The flag check
			// has to live in the LOGIC rather than the payload: these rules are
			// `insertion: 'unshift'`, so they sit ahead of every rule in default.js
			// and a matched-but-empty payload here would swallow the click instead
			// of letting the catch-all see it.
			logic: ({ eventData: { url = '' } = {}, flags } = {}) =>
				!isAdobeUpdatesOn({ flags }) && url.includes('mailto:'),
			payload: {
				type: 'CustomTagEvent',
				eventName: 'CTA',
				eventAction: 'buttonClick',
				attributes: {
					linkText: 'custom-factory-orders:staff-email'
				}
			},
			trigger: 'telephonicURL'
		}
	}
};
